import React, { useEffect, useState } from 'react';
import View from './View';
import useContact from '../../../../hooks/api/useContact';
import Contact, { EditContactOptions } from '../../../../interfaces/api/Contact';
import ConfirmationDialog from 'src/components/ConfirmationDialog';

const ViewContainer = ({ history, match, ...props }) => {
  const { get, disable, enable, update } = useContact();

  const [contact, setContact] = useState<Contact>();
  const [error, setError] = useState<string>();
  const [loading, setLoading] = useState(false);
  const [disabledContactDialogOpened, setDisabledContactDialogOpened] = useState(false);

  useEffect(() => {
    const contactId = match.params.id;

    setLoading(true);
    get(contactId)
      .then((contact: Contact) => {
        setContact(contact);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        setError(e.message);
      });
  }, []);

  const handleContactDisable = async () => {
    if (contact) {
      const newContact = await disable(contact.id);
      setContact(newContact);
      setDisabledContactDialogOpened(false);
    }
  };

  const handleContactEnable = async () => {
    if (contact) {
      const newContact = await enable(contact.id);
      setContact(newContact);
    }
  };

  const handleUpdateContact = async (updatedContact: EditContactOptions) => {
    if (contact) {
      const newContact = await update(contact.id, updatedContact);
      setContact(newContact);
    }
  };

  return (
    <>
      <View
        contact={contact}
        disableContact={() => setDisabledContactDialogOpened(true)}
        enableContact={handleContactEnable}
        updateContact={handleUpdateContact}
        error={error}
        loading={loading}
        history={history}
        {...props}
      />

      <ConfirmationDialog
        title='Attention'
        confirmationText='Confirmer'
        description='Vous allez désactiver ce contact. Êtes-vous sûr ?'
        open={disabledContactDialogOpened}
        onClose={() => setDisabledContactDialogOpened(false)}
        onValidate={handleContactDisable}
      />
    </>
  );
};

export default ViewContainer;
